import { Organizer }     from '../Organizer/Organizer';
import { createUniqKey } from 'Utils';
import { UserTicket, IUserTicket }   from '../UserTicket/UserTicket';
import { ORGANISATION_OWNER } from '../../../Config/Roles';


export interface IAppUser {
  id: string,
  username: string,
  email: string,
  firstname: string,
  lastname: string,
  street: string,
  postcode: string,
  city: string,
  country: string,
  addressAdditionalLine1: string,
  addressAdditionalLine2: string,
  allowNotifications: boolean,
  allowEmails: boolean,
  pushNewVenues: boolean,
  pushFavoriteEvents: boolean,
  pushNewLocations: boolean,
  pushTicketUpdates: boolean,
  pushNewTickets: boolean,
  organisation: Organizer | null,
  userRole: string | null,
  purchasedTickets: UserTicket[],
  ownedTickets: UserTicket[],
  createdAt: Date | null,
}

export class AppUser {
  public _key: string;
  public id: string;
  public username: string;
  public email: string;
  public firstname: string;
  public lastname: string;
  public street: string;
  public postcode: string;
  public city: string;
  public country: string;
  public addressAdditionalLine1: string;
  public addressAdditionalLine2: string;
  public allowNotifications: boolean;
  public allowEmails: boolean;
  public pushNewVenues: boolean;
  public pushFavoriteEvents: boolean;
  public pushNewLocations: boolean;
  public pushTicketUpdates: boolean;
  public pushNewTickets: boolean;
  public userRole: string | null;
  public organisation: Organizer | null;
  public purchasedTickets: UserTicket[];
  public ownedTickets: UserTicket[];
  public createdAt: Date | null;


  constructor(data: IAppUser) {
    this._key = createUniqKey();
    this.createdAt = data.createdAt ? new Date(data.createdAt as unknown as number * 1000) : null;

    this.id = data.id;
    this.userRole = null;
    this.organisation = data.organisation ? new Organizer(data.organisation) : null;

    if(this.organisation) {
      // @ts-ignore ignore role key its only needed for the correct user role
      this.userRole = data.organisation ? data.organisation?.role ? data.organisation.role.name : ORGANISATION_OWNER.key : null;
      this.organisation._userRole = this.userRole;
    }

    this.purchasedTickets = data.purchasedTickets ? data.purchasedTickets.map((ticket: UserTicket) => new UserTicket(ticket as unknown as IUserTicket)) : [];
    this.ownedTickets = data.ownedTickets ? data.ownedTickets.map((ticket: UserTicket) => new UserTicket(ticket as unknown as IUserTicket)) : [];

    this.username = data.username;
    this.email = data.email;
    this.firstname = data.firstname;
    this.lastname = data.lastname;
    this.street = data.street;
    this.postcode = data.postcode;
    this.city = data.city;
    this.country = data.country;
    this.addressAdditionalLine1 = data.addressAdditionalLine1;
    this.addressAdditionalLine2 = data.addressAdditionalLine2;
    this.allowNotifications = data.allowNotifications;
    this.allowEmails = data.allowEmails;
    this.pushNewVenues = data.pushNewVenues;
    this.pushFavoriteEvents = data.pushFavoriteEvents;
    this.pushNewLocations = data.pushNewLocations;
    this.pushTicketUpdates = data.pushTicketUpdates;
    this.pushNewTickets = data.pushNewTickets;

  }
}

export const createNewAppUser = (data: Partial<IAppUser> = {}): AppUser => new AppUser({
  id: data.id || 'new',
  createdAt: data.createdAt || null,
  username: data.username || '',
  email: data.email || '',
  firstname: data.firstname || '',
  lastname: data.lastname || '',
  street: data.street || '',
  postcode: data.postcode || '',
  city: data.city || '',
  country: data.country || '',
  addressAdditionalLine1: data.addressAdditionalLine1 || '',
  addressAdditionalLine2: data.addressAdditionalLine2 || '',
  allowNotifications: data.allowNotifications || false,
  allowEmails: data.allowEmails || false,
  pushNewVenues: data.pushNewVenues || false,
  pushFavoriteEvents: data.pushFavoriteEvents || false,
  pushNewLocations: data.pushNewLocations || false,
  pushTicketUpdates: data.pushTicketUpdates || false,
  pushNewTickets: data.pushNewTickets || false,
  organisation: data.organisation || null,
  userRole: data.userRole || null,
  purchasedTickets: data.purchasedTickets || [],
  ownedTickets: data.ownedTickets || [],
});
